import React from "react";
import "./Key_Highlights.css";

const Key_Highlights = ({ program }) => {
  const programData = Array.isArray(program) ? program[0] : program;
  const highlights = programData?.key_highlights || [];

  // const features = [
  //   "Comprehensive Technology Stack Coverage",
  //   "Mentorship by Top Notch Industry Experts",
  //   "Industry-Aligned Curriculum",
  //   "End-to-End Project-Based Training",
  //   "Career-Focused Learning Journey",
  //   "Global Certifications & Recognition",
  // ];

  return (
    <section className="Key_Highlights">
      <div className="container">
        <div className="Key_Highlights_header">
          <h5 className="Key_Highlights_title">
            Key Highlights of <span>{program.name}</span>
          </h5>
        </div>

        <div className="feature_section">
          <div className="row g-4 justify-content-center">
            {highlights.length > 0 ? (
              highlights.map((item, index) => (
                <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                  <div className="feature_box">
                    <p>{item.highlight}</p>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center">
                <p className="text-muted">No Key Highlights Available</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Key_Highlights;
